
const TestimonialSection = () => {
  const testimonials = [
    {
      quote: "AZZ MATRIX transformed our IT infrastructure completely. Their cloud migration service was seamless, and the ongoing support has been exceptional. Our team productivity increased by 40% in just three months.",
      author: "Marcus Chen",
      role: "CTO, TechFlow Solutions",
      avatar: "https://public.readdy.ai/ai/img_res/e4b582e6cd1cefcc27a40cf9363d94f9.jpg"
    },
    {
      quote: "The cybersecurity audit revealed vulnerabilities we didn't even know existed. AZZ MATRIX's team not only identified the issues but implemented comprehensive protection measures. We finally feel secure.",
      author: "Sarah Williams",
      role: "Operations Director, FinanceHub",
      avatar: "https://readdy.ai/api/search-image?query=professional%20caucasian%20female%20business%20executive%20in%20corporate%20office%20wearing%20professional%20attire%20confident%20expression%20modern%20workspace&width=400&height=400&seq=testimonial-sarah-williams-002&orientation=squarish"
    },
    {
      quote: "Their IT helpdesk support is outstanding. Response times are incredibly fast, and they always resolve our issues on the first call. It's like having an in-house IT department without the overhead costs.",
      author: "David Rodriguez",
      role: "CEO, GrowthLabs Inc",
      avatar: "https://readdy.ai/api/search-image?query=professional%20hispanic%20male%20business%20leader%20in%20executive%20office%20wearing%20suit%20confident%20professional%20demeanor%20contemporary%20office%20setting&width=400&height=400&seq=testimonial-david-rodriguez-003&orientation=squarish"
    }
  ];

  return (
    <section className="py-16 sm:py-24 bg-gradient-to-b from-indigo-950 to-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-block px-4 py-2 bg-violet-500/20 border border-violet-500/30 text-violet-300 text-xs sm:text-sm font-semibold rounded-full mb-4">
            Client Success Stories
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">Trusted by Growing Businesses</h2>
          <p className="text-base sm:text-lg text-gray-400 max-w-3xl mx-auto px-4">
            See how AZZ MATRIX has helped companies like yours achieve their IT goals and drive business growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-slate-800/50 backdrop-blur-sm border border-violet-500/20 rounded-2xl p-6 sm:p-8 hover:bg-slate-800 hover:border-violet-500/40 transition-all duration-300 hover:shadow-xl hover:shadow-violet-500/10"
            >
              <div className="mb-4 sm:mb-6">
                <i className="ri-double-quotes-l text-4xl sm:text-6xl text-violet-500 opacity-50"></i>
              </div>
              <p className="text-gray-300 text-sm sm:text-base leading-relaxed mb-6 sm:mb-8">
                {testimonial.quote}
              </p>
              <div className="flex items-center space-x-3 sm:space-x-4">
                <img 
                  src={testimonial.avatar}
                  alt={testimonial.author}
                  className="w-12 sm:w-14 h-12 sm:h-14 rounded-full object-cover border-2 border-violet-500"
                />
                <div>
                  <h4 className="text-white font-bold text-sm sm:text-base">{testimonial.author}</h4>
                  <p className="text-gray-400 text-xs sm:text-sm">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
